import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/stickyMenu.js";
import DesktopNavigation from "./DesktopNavigation";
import img1 from "../../assets/images/img1.jpg";

function StickyMenu() {
  useEffect(() => {
    const updateStickyMenu = () => {
      const stickyMenu = document.querySelector(".sticky-menu");
      if (stickyMenu) {
        stickyMenu.classList.toggle("sticky", window.scrollY > 160);
      }
    };

    window.addEventListener("scroll", updateStickyMenu);
    updateStickyMenu();

    return () => window.removeEventListener("scroll", updateStickyMenu);
  }, []);

  return (
    <Styles>
      <section className="sticky-menu">
        <Container>
          <Row>
            <Col md="2">
              <div className="logo">
                <Link to={process.env.PUBLIC_URL + "/"}>
                  <img src={img1} width={171} height="10%" alt="Study Concerns" />
                </Link>
              </div>
            </Col>
            <Col md="10">
              <div className="menu-box d-flex justify-content-end">
                <DesktopNavigation />
                <div className="apply-btn">
                  <Link to={process.env.PUBLIC_URL + "/apply"}>
                    <i className="las la-clipboard-list"></i>Apply Now
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default StickyMenu;
